module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "path-chart wrapper col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-7 chart"
  }, [_c('canvas', {
    ref: "chart",
    staticClass: "chart-canvas"
  })]), _vm._v(" "), _c('div', {
    ref: "legend",
    staticClass: "legend col-lg-5"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9499fb88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/charts/Pie.vue
// module id = 2107
// module chunks = 2